export const handleOrientationChange = () => {
  if (window.matchMedia("(orientation: portrait)").matches) {
    return true;
  } else {
    return false;
  }
};
